import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson9: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] mix-blend-normal text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson8"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">CEX vs DEX</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson10"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[9.5rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-[1.88rem] text-white font-dm-sans">

        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Why Are There Different Types of Exchanges?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>{`CEX (Centralized Exchange) and DEX (Decentralized Exchange) are two different types of cryptocurrency exchanges that operate differently in terms of centralization, security, and control. CEX is a centralized exchange where users trade cryptocurrencies through a centralized platform that is owned and controlled by a single entity. `}</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>{`CEXs are popular because they offer high liquidity, easy-to-use interfaces, and a wide range of trading tools and features. CEXs typically charge trading fees, withdrawal fees, and deposit fees. DEX, on the other hand, is a decentralized exchange that operates on a distributed network of computers, making it more secure and less vulnerable to hacking and fraud. DEXs allow users to trade cryptocurrencies in a peer-to-peer (P2P) manner without the need for a centralized intermediary. DEXs typically charge lower trading fees than CEXs, as they do not have the same overhead costs associated with running a centralized platform. In terms of taxes, both CEX and DEX trades are generally subject to capital gains taxes, which vary depending on the jurisdiction in which the trader is located. Traders should consult with a tax professional to understand the tax implications of their cryptocurrency trades. When it comes to fees, CEXs and DEXs differ in terms of the fees they charge. `}</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>{`CEXs typically charge higher fees than DEXs because they have higher overhead costs associated with running a centralized platform. CEXs often charge trading fees that range from 0.1% to 1% of the transaction value, as well as withdrawal fees and deposit fees. DEXs, on the other hand, typically charge lower trading fees that range from 0.1% to 0.3% of the transaction value, as they do not have the same overhead costs associated with running a centralized platform. However, DEXs may charge network fees associated with the blockchain used to execute the trades. `}</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Overall, both CEXs and DEXs have their advantages and
                disadvantages in terms of centralization, security, and fees.
                Traders should carefully consider their needs and preferences
                before choosing an exchange to use for their cryptocurrency
                trades.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[89.75rem] h-[46.73rem] object-cover"
          alt=""
          src="/i43@2x.png"
        />
        <b className="self-stretch relative tracking-[0.02em] leading-[2rem] text-center">
          Centralized Exchanges: Pros
        </b>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">User-Friendly</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                {`A CEX like Binance focuses on providing user-friendly experiences for all kinds of users. Newcomers to crypto have access to simple conversion tools like `}
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://www.binance.com/en/blog/otc/all-you-need-to-know-about-binance-convert-421499824684904009"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">
                    Binance Convert
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>{`, while experienced traders can use the `}</span>
            </span>
            <a
              className="text-[inherit]"
              href="https://academy.binance.com/en/articles/what-is-a-spot-market-and-how-to-do-spot-trading"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">
                    Spot Exchange's
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>{` `}</span>
            </span>
            <a
              className="text-[inherit]"
              href="https://academy.binance.com/en/articles/a-beginner-s-guide-to-tradingview"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">
                    TradingView tools
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>.</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The process of registering with a CEX is similar to opening a
                bank account. Many of us are already familiar with this system,
                and technical knowledge is not a must-have. Most CEXs offer
                payment with credit or debit cards, making your first crypto
                investment as simple as possible.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">{`Support & Protection`}</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                {`One of the biggest hurdles for crypto beginners when using DEXs is getting used to decentralized tools. Crypto wallets, `}
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://academy.binance.com/en/glossary/address"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">addresses</span>
                </span>
              </span>
            </a>
            <span>
              <span>
                {`, gas fees, and other aspects of blockchain can be unforgiving when you make mistakes. There are no system admins to offer assistance, so you're on your own if you lose your `}
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://academy.binance.com/en/glossary/seed-phrase"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">
                    seed phrase
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span> or send crypto to the wrong wallet.</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                You can avoid these pitfalls if you trade using a CEX. For
                example, customer support can help if you lose access to your
                Binance account, and there's no need to pay gas fees when moving
                your crypto around Binance's products. These measures support
                users and protect them from making the irreversible mistakes
                people sometimes make on DEXs.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">More Integrated Services</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                {`A CEX can offer a wide range of products and integrated services, turning it into a one-stop crypto shop. On a CEX like Binance, you can access trading and `}
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://academy.binance.com/en/articles/what-is-staking"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">staking</span>
                </span>
              </span>
            </a>
            <span>
              <span>{` services, an `}</span>
            </span>
            <a
              className="text-[inherit]"
              href="https://academy.binance.com/en/articles/a-guide-to-crypto-collectibles-and-non-fungible-tokens-nfts"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">NFT</span>
                </span>
              </span>
            </a>
            <span>
              <span>{` marketplace, a `}</span>
            </span>
            <a
              className="text-[inherit]"
              href="https://academy.binance.com/en/glossary/initial-exchange-offering"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">launchpad</span>
                </span>
              </span>
            </a>
            <span>
              <span>{`, a `}</span>
            </span>
            <a
              className="text-[inherit]"
              href="https://www.binance.com/en/blog/p2p/intro-to-peertopeer-trading-what-is-p2p-trading-and-how-does-a-local-bitcoin-exchange-work-421499824684901839"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">
                    P2P exchange
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>
                , and more without leaving the platform. Moreover, moving funds
                among these different areas is simple. You can pay by card and
                even enjoy deals with partner merchants like Travala..
              </span>
            </span>
          </p>
        </div>
        <b className="self-stretch relative tracking-[0.02em] leading-[2rem] text-center">
          Centralized Exchanges: Cons
        </b>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Susceptibility to Attack</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                As large centralized entities, CEXs are frequently the targets
                of attacks, which means any user funds stored on a CEX are
                susceptible to theft. While CEXs prioritize security, they
                cannot eliminate the risk of hacks and theft. Over the years,
                several high-profile hacks have occurred, such as the Mt. Gox
                hack.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Additional Transaction Fees</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Almost every — if not every — service you use on a CEX will
                incur a transaction fee. Often, it may be hidden or "baked into"
                the service. Due to their higher operating costs, CEXs may
                struggle to compete with the low transaction fees offered by
                DEXs. However, a CEX’s additional transaction fees must be
                weighed against the gas fees of using a DEX, which can be
                considerable on some networks.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>No User Custody of Assets</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When using a CEX, you must deposit your crypto into its wallet.
                This means you relinquish custody of your funds by entrusting
                them to the CEX. As such, you may be unable to withdraw them
                whenever you please. This is problematic if an exchange becomes
                insolvent and can lead to you losing your funds entirely. This
                situation is similar to storing your cash with a bank — during a
                run on the bank, you may not be able to access your funds.
              </span>
            </span>
          </p>
        </div>
        <b className="self-stretch relative tracking-[0.02em] leading-[2rem] text-center">
          Decentralized Exchanges: Pros
        </b>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Custody of Funds</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When using a DEX, you never lose custody of your funds until a
                trade or interaction is complete. This means you can move and
                store them as you wish. If your crypto is stored in a wallet
                whose seed phrase only you can access, you have total control
                over your assets. To decentralization advocates, this is one of
                the most critical factors.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Data Protection and Privacy</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When using a DEX, there’s no need to supply personal,
                identifying information and trust it to be stored securely. This
                means your personal data is safe from bad actors who want to
                steal your identity. Note that when using an exchange, you are
                still bound by local regulations and laws.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Lower Barriers to Entry</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Using a DEX requires only a wallet and some crypto to trade and
                pay gas fees. This makes DEXs highly accessible to a larger
                group of people globally. For decentralization fans, this is a
                huge benefit, and many value the more private nature of a DEX.
                Of course, this should also be considered in the context of
                local legislation, as well as relevant debates on crypto
                regulation.
              </span>
            </span>
          </p>
        </div>
        <b className="self-stretch relative tracking-[0.02em] leading-[2rem] text-center">
          Decentralized Exchanges: Cons
        </b>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Complex to Use and to enter</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                {`For a first-time user, understanding how to navigate and use a DEX can be challenging. Gas fees, `}
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://academy.binance.com/en/articles/what-are-liquidity-pools-in-defi"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">
                    liquidity pools
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>{`, wallets, and `}</span>
            </span>
            <a
              className="text-[inherit]"
              href="https://academy.binance.com/en/articles/bid-ask-spread-and-slippage-explained"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">slippage</span>
                </span>
              </span>
            </a>
            <span>
              <span>
                {" "}
                are all possible hurdles to overcome. It takes time to grasp how
                a DEX works confidently, and to invest responsibly, you should
                always understand your tools.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Lack of Fiat On and Off Ramps</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Historically, buying your first coin or token was one of the
                most significant barriers to gaining crypto exposure. CEXs now,
                as a standard, offer credit and debit card options for buying
                crypto. Although some DEXs are beginning to offer this service
                with third-party providers, most still don't allow credit or
                debit card usage.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Liquidity Struggles</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>{`DEXs, on average, have smaller `}</span>
            </span>
            <a
              className="text-[inherit]"
              href="https://academy.binance.com/en/glossary/volume#:~:text=Volume%2C%20or%20trading%20volume%2C%20is,a%20buyer%20and%20a%20seller."
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">volumes</span>
                </span>
              </span>
            </a>
            <span>
              <span>{` and less liquidity than large CEXs. `}</span>
            </span>
            <a
              className="text-[inherit]"
              href="https://www.binance.com/en/support/faq/understanding-order-book-and-market-depth-da311403b10347f09ff783a2525c8aa6"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">
                    Market depth
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>
                {" "}
                can be smaller, and large trades on a DEX may have a more
                significant price impact than if done on a CEX. Traders or
                investors making large volume orders can often find a better
                price doing over-the-counter (OTC) trades or using a CEX with
                deep order books, like Binance.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Should I Use a DEX or a CEX?</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                By far, the simplest experience for a crypto beginner is to use
                a CEX. It removes the initial learning curve associated with
                decentralized blockchain infrastructure. If you face any issues
                using a CEX, a support team will help and guide you as much as
                possible.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Overall, the chances of making an irreversible mistake like
                losing access to your funds or transferring it to the wrong
                address are much lower with a CEX. So if it's your first time
                gaining crypto exposure or you prefer a more straightforward,
                digestible service, a CEX is for you.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                {`A DEX, on the other hand, is an excellent gateway to the world of `}
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://academy.binance.com/en/articles/the-complete-beginners-guide-to-decentralized-finance-defi"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">DeFi</span>
                </span>
              </span>
            </a>
            <span>
              <span>{`. With a single Ethereum `}</span>
            </span>
            <a
              className="text-[inherit]"
              href="https://academy.binance.com/en/glossary/virtual-machine"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">
                    Virtual Machine
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>
                {" "}
                (EVM) wallet, you can explore the vast DeFi universe. A DEX is a
                versatile option for crypto power users and offers a high degree
                of freedom.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                {`If you're looking to invest in an extensive range of new projects with low `}
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://academy.binance.com/en/articles/crypto-market-capitalization-explained"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">
                    market caps
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>
                , a DEX is also your best bet. While CEXs often launch new
                tokens, DEXs still facilitate most new token sales and
                liquidity.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Considering the above, and to help you decide at a glance, refer
                to the following use cases for each exchange type:
              </span>
            </span>
          </p>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson10">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson9;
